export const inspectTable_1 = [
  {
    key: 't1-001',
    title: '1. (물) 시원한 물 자주 마시기',
    content: '• 시원하고 깨끗한 물을 충분히 제공',
    isChecked: ''
  },
  {
    key: 't1-002',
    title: '2. (바람·그늘) 실내·옥외 작업장 온도 낮추기',
    content: '• 실내·옥외작업 시 (이동식)에어컨, 산업용 선풍기 등 냉방·통풍장치 및 그늘막 설치',
    isChecked: ''
  },
  {
    key: 't1-003',
    title: '2. (바람·그늘) 실내·옥외 작업장 온도 낮추기',
    content: '• 직업시간대 조정 등 폭염 집중 시간대 노출 최소화',
    isChecked: ''
  },
  {
    key: 't1-004',
    title: '3. (휴식) 주기적으로 쉬기',
    content: '• 작업장소의 가까운 곳에 휴게시설(실내) 설치, (이동식)에어컨, 산업용 선풍기, 시원한 물 비치',
    isChecked: ''
  },
  {
    key: 't1-005',
    title: '3. (휴식) 주기적으로 쉬기',
    content: '• 체감온도 31도 이상 폭염작업 시 적절한 휴식',
    isChecked: ''
  },
  {
    key: 't1-006',
    title: '3. (휴식) 주기적으로 쉬기',
    content: '• 체감온도 33도 이상 폭염작업 시 2시간 이내 20분 이상 휴식',
    isChecked: ''
  },
  {
    key: 't1-007',
    title: '4. (보냉장구) 근로자 체온 낮추기',
    content: '• 냉각의류, 냉각조끼 등 개인 보냉장구 지급',
    isChecked: ''
  },
  {
    key: 't1-008',
    title: '5. (응급조치) 119에 신고하기',
    content: '• 온열질환자·의심자가 의식이 없는 경우 즉시 119 에 신고',
    isChecked: ''
  },
  {
    key: 't1-009',
    title: '5. (응급조치) 119에 신고하기',
    content: '• 의식이 있는 경우 응급조치 후 중상 개선 없을 시 119 신고',
    isChecked: ''
  },
  {
    key: 't1-010',
    title: '6. 그 외 예방조치',
    content: '• 작업장소의 체감온도를 알 수 있는 온습도계 비치',
    isChecked: ''
  },
  {
    key: 't1-011',
    title: '6. 그 외 예방조치',
    content: '• 온열질환 증상 및 예방법, 응급조치 요령 교육',
    isChecked: ''
  },
  {
    key: 't1-012',
    title: '6. 그 외 예방조치',
    content: '• 체감온도를 측정하고 조치사항 기록·보관',
    isChecked: ''
  },
  {
    key: 't1-013',
    title: '6. 그 외 예방조치',
    content: '• 온열질환 민감군 관리계획 수립<br/><span style="padding-left:10px;font-weight:400;">* 신규배치자, 과거 온열질환 경력자, 고혈압 등</span>',
    isChecked: ''
  },
  {
    key: 't1-014',
    title: '6. 그 외 예방조치',
    content: '• 작업장소와 가까운 곳에 휴게시설(쉼터 및 그늘진 장소) 설치',
    isChecked: ''
  },
  {
    key: 't1-015',
    title: '6. 그 외 예방조치',
    content: '• 휴식시간 추가 배정 등 온열질환 민감군 관리, 폭염작업 시간 단축<br/><span style="padding-left:10px;font-weight:400;">* 신규배치자, 과거 온열질환 경력자, 고령자 등</span>',
    isChecked: ''
  },
];
export const inspectTable_2 = [
  {
    key: 't2-001',
    id: 1,
    content: '풍수해 대비 비상매뉴얼은 작성하는가?',
    isChecked: ''
  },
  {
    key: 't2-002',
    id: 2,
    content: '매뉴얼에 따른 업무분장이 적합한가?',
    isChecked: ''
  },
  {
    key: 't2-003',
    id: 3,
    content: '사전 비상대비 훈련을 실시하는가?',
    isChecked: ''
  },
  {
    key: 't2-004',
    id: 4,
    content: '예상 강우량에 따라 우수 유입량은 계산하는가?',
    isChecked: ''
  },
  {
    key: 't2-005',
    id: 5,
    content: '현장 구간 내 시설물에 대한 우수 등의 유입에 대한 안전성평가가 이루어지는가?',
    isChecked: ''
  },
  {
    key: 't2-006',
    id: 6,
    content: '배수계획도는 작성되었는가?',
    isChecked: ''
  },
  {
    key: 't2-007',
    id: 7,
    content: '수방자재는 확보되었는가?\n' +
      '※ 양수기(고장 시 대비 여유분 포함), 마대, 가마니, 삽, 리어카, 우비, 장화, 렌턴 등',
    isChecked: ''
  },
  {
    key: 't2-008',
    id: 8,
    content: '비상대기반을 편성하였는가?',
    isChecked: ''
  },
  {
    key: 't2-009',
    id: 9,
    content: '작업중지 명령 체계가 확립되었는가?',
    isChecked: ''
  },
  {
    key: 't2-010',
    id: 10,
    content: '발주처 및 원하청 간 비상 연락망은 구축되었으며 실제 운영하는가?',
    isChecked: ''
  },
  {
    key: 't2-011',
    id: 11,
    content: '비상사태 발생 시 이에 대한 대책 수립을 하는가?\n' +
      '※ 집중호우 시 자재 및 장비 대피 계획 등',
    isChecked: ''
  },
];
export const inspectTable_3 = [
  {
    key: 't3-001',
    id: 1,
    content: '우리 사업장에서 한랭작업이 발생하거나 취급하는지에 대해 분류･파악하고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-002',
    id: 2,
    content: '우리 사업장에서 한랭의 유해성･위험성 및 관리방안을 근로자에게 주지시키고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-003',
    id: 3,
    content: '작업환경측정 등을 통해 근로자에게 노출되는 한랭 노출수준을 관리하고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-004',
    id: 4,
    content: '측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-005',
    id: 5,
    content: '근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치하고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-006',
    id: 6,
    content: '저온환경의 격리와 작업장 내 온･습도 조절을 위한 난방장치 등이 설치되어 있는가?',
    isChecked: ''
  },
  {
    key: 't3-007',
    id: 7,
    content: '작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-008',
    id: 8,
    content: '비상시 온도를 낮추거나 열을 차단할 수 있는 난방시스템이 구축되어 있는가?',
    isChecked: ''
  },
  {
    key: 't3-009',
    id: 9,
    content: '근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?',
    isChecked: ''
  },
  {
    key: 't3-010',
    id: 10,
    content: '다량의 저온물체를 취급하는 장소 등에 관계근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?',
    isChecked: ''
  },
];

export const inspectTable_4 = [
  {
    key: 't4-001',
    title: '따뜻한 옷(방한장구)',
    content: '3겹 이상의 옷을 입고 있는가?',
    isChecked: ''
  },
  {
    key: 't4-002',
    title: '따뜻한 옷(방한장구)',
    content: '모자, 두건 착용을 권장하고 있는가?',
    isChecked: ''
  },
  {
    key: 't4-003',
    title: '따뜻한 옷(방한장구)',
    content: '얼굴과 입을 가리는 마스크를 사용하는가?',
    isChecked: ''
  },
  {
    key: 't4-004',
    title: '따뜻한 옷(방한장구)',
    content: '보온·방수 장갑 및 신발을 착용하고 있는가?<br/>※ 물에 젖기 쉬운 작업을 하는 경우에는 방수 기능이 추가된 장갑을 착용.<br/>※ 영하 7℃ 이하에서는 맨 손으로 금속 표면을 잡지 말고 반드시 장갑 착용',
    isChecked: ''
  },
  {
    key: 't4-005',
    title: '따뜻한 물',
    content: '따뜻하고 깨끗한 물이 제공되는가?<br/>' +
      '※ 쉬고자 하는 근로자를 충분히 수용<br/>' +
      '※ 히터나 난로 등을 설치 시 화재나 유해가스 중독 등의 우려가 없도록 하여야 함',
    isChecked: ''
  },
  {
    key: 't4-006',
    title: '따뜻한 장소',
    content: '따뜻한 장소를 작업장소 가까운 곳에 제공하는가?<br/>※ 수시로 따뜻한 물을 마실 수 있도록 보온병 등 설치',
    isChecked: ''
  },
  {
    key: 't4-007',
    title: '따뜻한 장소',
    content: '한파 특보 시 적정한 휴식시간을 제공하고 있는가?',
    isChecked: ''
  },
  {
    key: 't4-008',
    title: '따뜻한 장소',
    content: '한랭질환 예방교육을 실시하였는가?<br/>' +
      '- 한랭질환 주요증상<br/>' +
      '- 작업 중 동료 근로자의 증상여부 및 민감군* 수시확인<br/>' +
      ' * 민감군 : 고혈압, 당뇨, 뇌심혈관질환, 허약체질, 고령자 등<br/>' +
      '- 저체온증 등 한랭질환예방 3대 수칙(따뜻한 옷‧물‧장소)<br/>' +
      '- 운동지도 및 응급조치 요령',
    isChecked: ''
  },
]


export const inspectTable_5 = [
  {
    key: 't5-001',
    title: '따뜻한 옷',
    content: '따뜻한 옷, 방한모, 장갑 착용',
    isChecked: ''
  },
  {
    key: 't5-002',
    title: '따뜻한 옷',
    content: '보온과 방수 기능이 있는 신발 착용',
    isChecked: ''
  },
  {
    key: 't5-003',
    title: '따뜻한 쉼터 [휴식]',
    content: '추위를 피해 쉴 수 있는 <b>따뜻한 쉼터를 작업장소와 가까운 곳에 설치</b><br/>' +
      '※ 난방장치를 설치하고 화재 및 유해가스 중독 등의 예방조치 실시',
    isChecked: ''
  },
  {
    key: 't5-004',
    title: '따뜻한 쉼터 [휴식]',
    content: '한파특보 발령 시 <b>적절하게 휴식 부여</b>',
    isChecked: ''
  },
  {
    key: 't5-005',
    title: '따뜻한 쉼터 [휴식]',
    content: '휴식시간에 이용할 수 있는 <b>휴게시설을 설치하고 설치 관리 기준 준수</b><br/>' +
      '※ (설치·관리 기준 준수) 크기, 온도, 위치, 등 적정기준 준수 여부 확인',
    isChecked: ''
  },
  {
    key: 't5-006',
    title: '따뜻한 물',
    content: '따뜻하고 깨끗한 물 제공',
    isChecked: ''
  },
  {
    key: 't5-007',
    title: '작업시간대 조정',
    content: '한파특보(주의보) 발령 시 작업시간 조정 및 작업시간 단축',
    isChecked: ''
  },
  {
    key: 't5-008',
    title: '작업시간대 조정',
    content: '한파특보(경보) 발령 시 추운시간대(새벽) 옥외 작업중지 및 최소화',
    isChecked: ''
  },
  {
    key: 't5-009',
    title: '응급조치 [119신고]',
    content: '한파작업 노동자의 <b>한랭질환자(의심자) 발생 시 즉지 119 신고</b><br/>' +
      '※ 건강장해의 증상 및 예방조치 응급조치 요령을 미리 알릴 것',
    isChecked: ''
  },
  {
    key: 't5-010',
    title: '한랭질환 민감군 관리',
    content: '한파특보 시 <b>한랭질환 민감군 및 중작업 수행 노동자 중점 관리</b><br/>' +
      '※ (민감군) 고혈압, 당뇨, 뇌심혈관질환, 고령자, 신규배치자 등<br>' +
      '※ (중작업) 중량물을 수작업에 의해 반복적을 취급하는 작업',
    isChecked: ''
  },
]
